<template>
  <ul
    v-if="hits.length"
    data-testid="searchResultsList"
  >
    <li
      v-for="(hit, i) in hits"
      :key="getHitKey(hit, i)"
      class="py-4 list-none"
      :class="{ 'bg-EXPONDO-grey-20': activeIndex === i }"
      data-testid="searchResultsItem"
    >
      <CustomLink
        :text="hit.name"
        :url="hit.url"
        :type="LINK_TYPE.NoStyle"
        @link-click="onClickHandler(hit)"
      >
        <div class="flex items-center text-EXPONDO-black">
          <ImgView
            :src="hit.image ?? ''"
            :alt="hit.imageAlt"
            img-classes="min-w-[2.5rem] w-10 h-10 object-contain lg:w-12 lg:h-12 lg:min-w-[3rem]"
          />
          <span class="px-5 text-sm line-clamp-3">{{ hit.name }}</span>
          <span class="ml-auto font-bold">{{ $n(hit.price, 'currency') }}</span>
        </div>
      </CustomLink>
    </li>
  </ul>
  <!-- Typesense fallback: only mounted (and only ever needed) when no explicit `hits` prop is
       passed — CtSearchBar.vue always passes `hits` explicitly and never mounts this, since it has
       no InstantSearch instance anywhere in its tree for ais-hits to inject from. -->
  <ais-hits
    v-else
    v-slot="{ items }"
  >
    <ul data-testid="searchResultsList">
      <li
        v-for="(hit, i) in items"
        :key="getHitKey(hit, i)"
        class="py-4 list-none"
        :class="{ 'bg-EXPONDO-grey-20': activeIndex === i }"
        data-testid="searchResultsItem"
      >
        <CustomLink
          :text="hit.name"
          :url="hit.url"
          :type="LINK_TYPE.NoStyle"
          @link-click="onClickHandler(hit)"
        >
          <div class="flex items-center text-EXPONDO-black">
            <ImgView
              :src="hit.image ?? ''"
              :alt="hit.imageAlt"
              img-classes="min-w-[2.5rem] w-10 h-10 object-contain lg:w-12 lg:h-12 lg:min-w-[3rem]"
            />
            <span class="px-5 text-sm line-clamp-3">{{ hit.name }}</span>
            <span class="ml-auto font-bold">{{ $n(hit.price, 'currency') }}</span>
          </div>
        </CustomLink>
      </li>
    </ul>
  </ais-hits>
</template>

<script lang="ts">

import type { HitResultItem } from 'vue-instantsearch/vue3/es';
import { AisHits } from 'vue-instantsearch/vue3/es';
import { LINK_TYPE } from '~~/types/components/Link/LinkType';

export default defineComponent({
  name: 'SearchBarResults',
  components: {

    AisHits,
  },
  props: {
    activeIndex: {
      type: Number,
      required: true,
    },
    hits: {
      type: Array as PropType<HitResultItem[]>,
      default: () => ([]),
    },
  },
  emits: ['product-clicked', 'search-results-shown'],
  setup(props, { emit }) {

    const onClickHandler = (hit: HitResultItem) => {

      emit('product-clicked', hit);

    };

    const getHitKey = (hit: HitResultItem, index: number): string | number =>
      hit.objectID ?? index;

    onMounted(() => {

      emit('search-results-shown');

    });

    return {
      onClickHandler,
      getHitKey,
      LINK_TYPE,
    };

  },
});


</script>
